// removed by extract-text-webpack-plugin
module.exports = {"Header":"_2CVoQ68R3ulYQrwea2rYMF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/styles.css
// module id = 743
// module chunks = 0